import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from '../mutation-types';
import authHelper from '../../helpers/auth';
import apiAuth from '../../api/auth';
import alertHelper from '../../helpers/alert';

const defaultState = () => ({
    isAuth: authHelper.loggedIn(),
    isAttempting: false,
    alerts: [],
    fieldErrors: {},
    userData: authHelper.getUserData(),
    is_have_pin: authHelper.getUserHavePin(),
});

const state = defaultState();

const getters = {
    isAuth(state) {
        return state.isAuth;
    },
};

const mutations = {
    attempting(state) {
        state.isAttempting = true;
        state.fieldErrors = {};
        state.alerts = [];
    },
    attempted(state) {
        state.isAttempting = false;
    },
    failed(state, { code, type, message }) {
        state.alerts = alertHelper.make(state.alerts, code, type, message);
    },
    validationError(state, errors) {
        state.fieldErrors = Object.assign({}, state.fieldErrors, errors);
    },
    success(state, authData) {
        state.userData = Object.assign({}, state.userData, authData.pos);
        state.isAuth = true;
        authHelper.setData(authData);
        state.fieldErrors = {};
        state.alerts = [];
    },
    setProfileData(state, data) {
        state.isAuth = true;
        authHelper.setProfileData(data);
        state.userData = authHelper.getUserData();
        state.fieldErrors = {};
        state.alerts = [];
    },
    removeAlert(state, id) {
        const index = Array.from(state.alerts).findIndex(it => it.id === id);

        if (index !== -1) {
            state.alerts.splice(index, 1);
        }
    },
    clearData(state) {
        state.isAuth = false;
        authHelper.clearData();
    },
    reset(state) {
        Object.assign(state, defaultState());
    },
    setHavePin(state, data) {
        state.is_have_pin = data;
    },
};

const actions = {
    login({ commit, dispatch }, { username, password }) {
        return new Promise((resolve) => {
            commit(PROGRESS_START, null, { root: true });
            commit('attempting');

            apiAuth.login(username, password).then((res) => {
                if (!res.data.data.otp && !res.data.data.pin) {
                    commit('success', res.data.data);
                }
                commit(PROGRESS_FINISH, null, { root: true });
                resolve(res.data.data);
            }).catch((err) => {
                const { data } = err.response;
                commit(PROGRESS_FAIL, null, { root: true });
                dispatch('errorHandler', data);
            }).then(() => {
                commit('attempted');
            });
        });
    },
    autoLogin({ commit, dispatch }, { mid, expired }) {
        return new Promise((resolve) => {
            commit(PROGRESS_START, null, { root: true });
            commit('attempting');

            apiAuth.autoLogin(mid, expired).then((res) => {
                if (!res.data.data.otp) {
                    commit('success', res.data.data);
                }
                commit(PROGRESS_FINISH, null, { root: true });
                resolve(res.data.data);
            }).catch((err) => {
                const { data } = err.response;
                commit(PROGRESS_FAIL, null, { root: true });
                dispatch('errorHandler', data);
            }).then(() => {
                commit('attempted');
            });
        });
    },
    loginOtp({ commit, dispatch }, { username, otp_code }) {
        return new Promise((resolve) => {
            commit(PROGRESS_START, null, { root: true });
            commit('attempting');

            apiAuth.loginOtp(username, otp_code).then((res) => {
                commit('success', res.data.data);
                commit('setHavePin', res.data.data.is_have_pin);
                commit(PROGRESS_FINISH, null, { root: true });
                resolve(res.data.data);
            }).catch((err) => {
                const { data } = err.response;
                commit(PROGRESS_FAIL, null, { root: true });
                dispatch('errorHandler', data);
            }).then(() => {
                commit('attempted');
            });
        });
    },
    loginPin({ commit, dispatch }, { username, pin_code }) {
        return new Promise((resolve) => {
            commit(PROGRESS_START, null, { root: true });
            commit('attempting');

            apiAuth.loginPin(username, pin_code).then((res) => {
                commit('success', res.data.data);
                commit('setHavePin', res.data.data.is_have_pin);
                commit(PROGRESS_FINISH, null, { root: true });
                resolve(res.data.data);
            }).catch((err) => {
                const { data } = err.response;
                commit(PROGRESS_FAIL, null, { root: true });
                dispatch('errorHandler', data);
            }).then(() => {
                commit('attempted');
            });
        });
    },
    loginSSO({ commit }, params) {
        return new Promise((resolve, reject) => {
            commit(PROGRESS_START, null, { root: true });
            commit('clearData');
            commit('attempting');

            apiAuth.loginSSO(params).then((res) => {
                commit('success', res.data.data);
                commit('setHavePin', res.data.data.is_have_pin);
                commit(PROGRESS_FINISH, null, { root: true });
                resolve(true);
            }).catch(() => {
                commit(PROGRESS_FAIL, null, { root: true });
                reject(true)
            }).then(() => {
                commit('attempted');
            });
        });
    },
    logout({ commit }) {
        commit('clearData');

        return Promise.resolve(true);
    },
    getTokenSso({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            commit(PROGRESS_START, null, { root: true });
            commit('attempting');

            apiAuth.getTokenSso().then(({ data: { data } }) => {
                commit(PROGRESS_FINISH, null, { root: true });
                resolve(data);
            }).catch((err) => {
                const { data } = err.response;
                commit(PROGRESS_FAIL, null, { root: true });
                reject(data)
                dispatch('errorHandler', data);
            }).then(() => {
                commit('attempted');
            });
        });
    },
    errorHandler({ commit }, response) {
        switch (response.message) {
            case 'error_validation':
                commit('validationError', response.data);
                break;

            default:
                commit('failed', { code: 'error_response', type: 'error', message: response.message });
                break;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};